import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const sendMessage = createAsyncThunk(
  "sendMS/sendMessage",
  async (createData, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post("/api/user/chat/send", createData);
      return response.data.data.chat_messages;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to create chat.");
    }
  }
);

const sendMSSlice = createSlice({
  name: "sendMS",
  initialState: {
    messages: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendMessage.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.messages = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.messages = action.payload;
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.messages = null; 
      });
  },
});

export default sendMSSlice.reducer;